import type { TBrand } from "@/lib/branded";

import { z } from "zod";

export function anemicReference<ID extends TBrand<number, unknown>>(id: z.ZodType<ID, z.ZodTypeDef, number>) {
  return z.object({
    id,
    description: z.string(),
  });
}

export interface AnemicReference<ID extends TBrand<number, unknown>> {
  id: ID;
  description: string;
}
